"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryAfterError = void 0;
var tslib_1 = require("tslib");
var CustomError_1 = require("./CustomError");
var RetryAfterError = /** @class */ (function (_super) {
    tslib_1.__extends(RetryAfterError, _super);
    function RetryAfterError(after) {
        var _this = _super.call(this, "Need to retry after " + after + " ms") || this;
        _this._retryAt = Date.now() + after;
        return _this;
    }
    Object.defineProperty(RetryAfterError.prototype, "retryAt", {
        get: function () {
            return this._retryAt;
        },
        enumerable: false,
        configurable: true
    });
    return RetryAfterError;
}(CustomError_1.CustomError));
exports.RetryAfterError = RetryAfterError;
//# sourceMappingURL=RetryAfterError.js.map